import { SET_LANGUAGE } from './constants'

export const setLanguage = (language: LanguageOption) => ({
  type: SET_LANGUAGE,
  language,
})
